// extracted by mini-css-extract-plugin
module.exports = {"section":"ContentBlocks_section__dLe_t","is_coverVideo":"ContentBlocks_is_coverVideo__17gqm"};